import { copy } from "@wheels-crm/shared-types";
import type { RejectReason } from "@wheels-crm/shared-types";
import { Modal } from "../ui/Modal";
import { Button } from "../ui/Button";

/**
 * Shown before committing a status change to "Відмова" (§6.4). Two reasons only, the labels
 * are intentionally NOT literal translations of the enum values — see AGENTS.md §7:
 * 'price' displays as "Відмова", 'not_relevant' displays as "Передумали".
 */
export function RejectReasonModal({
  onConfirm,
  onCancel,
}: {
  onConfirm: (reason: RejectReason) => void;
  onCancel: () => void;
}) {
  return (
    <Modal title={copy.field.rejectReasonLabel} onClose={onCancel}>
      <div className="modal-actions" style={{ justifyContent: "flex-start", marginTop: 0 }}>
        <Button variant="danger" onClick={() => onConfirm("price")}>
          {copy.rejectReason.price}
        </Button>
        <Button onClick={() => onConfirm("not_relevant")}>{copy.rejectReason.not_relevant}</Button>
      </div>
      <div className="modal-actions">
        <Button onClick={onCancel}>{copy.cancel}</Button>
      </div>
    </Modal>
  );
}
